import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = ["maxlength", "placeholder", "invalid"]
const _hoisted_3 = { style: { position: 'absolute', bottom: '1rem', right: '1rem' } }
const _hoisted_4 = {
  key: 0,
  class: "v-validation-message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("textarea", {
        ref: "inputRef",
        class: "configurator-textarea-input",
        maxlength: $setup.limit,
        placeholder: $setup.placeholder,
        invalid: $setup.shouldBlockValidation,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = $event => (($setup.value) = $event)),
          _cache[1] || (_cache[1] = 
          (val) => {
            $setup.setValue(val);
            $setup.debouncedUpdateCurrentLength();
          }
        )
        ],
        onInput: _cache[2] || (_cache[2] = (...args) => ($setup.debouncedUpdateCurrentLength && $setup.debouncedUpdateCurrentLength(...args)))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
        [_vModelText, $setup.value]
      ]),
      _createElementVNode("output", _hoisted_3, _toDisplayString($setup.currentLength) + "/" + _toDisplayString($setup.limit), 1 /* TEXT */)
    ]),
    _createVNode(_Transition, { name: "fade-up" }, {
      default: _withCtx(() => [
        ($setup.shouldBlockValidation)
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString($setup.nonFilledError), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 512 /* NEED_PATCH */)), [
    [_vShow, $setup.isEnabled]
  ])
}